import { environment } from '../../../environments/environment.prod';
//import { CartService } from '../../cart/services/cart.service';
//import { Cart } from "../../cart/interfaces/cart.interface";
import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter
} from "@angular/core";
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  NavigationStart
} from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { CommonService } from "../services/common.service";
import { SSO } from "./../../sso/sso.constants";
//import { SharedMessageService } from "../services/shared-message.service";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from "../../shared/services/cache.service";

@Component({
  selector: "country-language-selector",
    templateUrl: "../templates/template1/views/country-language.component.html",
  styleUrls: [
    "../templates/template1/themes/default/CSS/country-language.component.less"
  ]
})
export class CountryLanguageComponent implements OnInit {
  openSearch: boolean = false;
  isShowSearch: boolean = false;
  isModalShown: boolean = false;
  countryInfo: any;
  countryName: string;
  languages: any = [];
  continents: any[] = [];
  selectedLanguage: any;
  defaultLanguage: any;
  selectedLanguageName: any;
  selectedCountry: any = {
    countryCode: "",
    countryName: "",
    preferredLanguages: []
  };

  @Output("countryLanguageChange")
  countryLanguageChange: EventEmitter<any> = new EventEmitter<any>();
  countryLanguageCode = {
    countryCode: "",
    languageCode: ""
  };
  searchCountry: string = "";
  @ViewChild("autoShownModal") public autoShownModal: ModalDirective;

  constructor(
    private _commonService: CommonService,
    private _translate: TranslateService,
    private _cacheService:CacheService
    //private _sharedMessageService: SharedMessageService,
    //private _cartService:CartService
  ) {
    this.countryName = String(this._cacheService.get(CacheKey.CountryName));
  }

  ngOnInit() {

   this.selectedLanguage=this._cacheService.get(CacheKey.Language);
    if(this.selectedLanguage && this.selectedLanguage ==""){
          this.selectedLanguage = 'en-us';
    }    
    this._translate.use(this.selectedLanguage);
    this.getLanguages();
  }

  getLanguages(){
    this._commonService.getLanguages().subscribe(response=>{
      if(response){
      this.languages=response;
      let language=this._cacheService.get(CacheKey.Language);
      if(!language || language==undefined){
        this.selectedLanguageName = this.languages.find((x: any) => x.isDefaultLanguage == "true").languageName;
        let defaultLanguage= this.languages.find((x: any) => x.isDefaultLanguage == "true").languageCode;
        this._cacheService.set(CacheKey.DefaultLanguage,defaultLanguage);
        this._cacheService.set(CacheKey.Language, defaultLanguage);
      }
      else{
      this.selectedLanguageName=this.languages.find((x: any) => x.languageCode == language).languageName;
      }
      }
    })
  }
  /**
    * Assign Selectedlanguage from user.
    * @param language
    * @returns {void}
    */
  selectLanguage(language: any): void {
   
    this.selectedLanguage = language.languageCode;
    this.selectedLanguageName = language.languageName;
    //notifies header when the language changes
    this.countryLanguageCode.languageCode = this.selectedLanguage;
    this.countryLanguageChange.emit(this.countryLanguageCode);
    this._cacheService.set(CacheKey.Language, this.selectedLanguage);
   // this.translate();
    window.location.reload();
  }
  /**
   * To translate the text
   * @returns void
   */
  translate(): void {
    this.selectedLanguage = this._cacheService.get(CacheKey.Language);
    this.defaultLanguage = this._cacheService.get(CacheKey.DefaultLanguage);
    if (this.selectedLanguage != null && this.selectedLanguage != undefined) {
      this._translate.use(this.selectedLanguage);
    } else if (
      this.defaultLanguage != null &&
      this.defaultLanguage != undefined
    ) {
      this._translate.use(this.defaultLanguage);
    }
  }

  /**
    * to get configurations
    * @param  {string} country
    */
  getConfigurations(country: string) {
    this._commonService.getConfiguration(country).subscribe((config: any) => {
      if (config) {
        this._cacheService.set(CacheKey.Configuration, config);
       // window.location.href = environment.baseHref + country + "/shop";
      }
    });
  }

  /**
     * To show country selection popup
     * @param  {any} element
     * @param  {boolean} isShow
     */
  showPopup(element: any, isShow: boolean) {
    if (isShow) {
      element.classList.add("scaleup");
    } else {
      element.classList.remove("scaleup");
      this.searchCountry = "";
    }
  }
  /**
   * change country modal popup
   * @param  {any} country
   * @returns void
   */
  countryChangeModal(country: any): void {
    this.isModalShown = true;
    this.countryInfo = country;
  }

  /**
   * to open product search in mobile view
   * @param  {boolean} isOpen
   * @returns void
   */
//   openProductSearch(isOpen: boolean): void {
//     this._sharedMessageService.setOpenSearch(!isOpen);
//   }

  public hideModal(): void {
    this.autoShownModal.hide();
  }

  public onHidden(): void {
    this.isModalShown = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/country-language.component.ts